import authClient from './authClient';

export function refreshJWT(refreshToken, email) {
    return authClient.post(process.env.REACT_APP_API_URL + '/refreshJWT', { refreshToken, email });
}